(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["creachick-share"] && !Shopify.designMode) return;
  try {
    if (navigator.share)
  {
    const container = document.querySelector('.creachick-share-buttons');
    const shareButton = container.querySelector('li.creachick-share-button.native');
    
    shareButton.classList.remove('hidden');
    
    shareButton.addEventListener('click', async () => {
        const title = shareButton.dataset.title;
        const text = shareButton.dataset.text;
        const url = shareButton.dataset.url || window.location.href;

        try {
        await navigator.share({
            title: title,
            text: text,
            url: url
        });
        } catch (error) {
        console.log('Delen geannuleerd of mislukt:', error);
        }
    });
  } else {
    console.log('Deze browser ondersteunt native share niet');
  }
  } catch(e) { console.error(e); }
})();

})();
